import { initLocalization } from '@goalsetter/classroom-web-app-sdk/i18n';
import en from './locales/en';
import es from './locales/es';

/**
 * Copy stays in this app; the runtime (detection order, shared `language`
 * cookie, Ant Design / dayjs wiring) lives in the web app SDK.
 */
const i18n = initLocalization({
  resources: {
    en,
    es,
  },
});

export default i18n;
